angular.module("vgresiduos").factory("recipientService", [
	"$http",
	"accountService",
	function ($http, accountService) {
		"use strict";

		function getBaseCoreRequestUrl() {
			const currentOrganizationUnit = accountService.getCurrentClient();
			const organizationId = currentOrganizationUnit.organization.id;
			const organizationUnitCode = currentOrganizationUnit.code;
			return (
				Vgr.constants.coreHostUrl +
				Vgr.resources.core.organizationUnitRecipient
					.replace("[ORGANIZATION_ID]", organizationId)
					.replace("[ORGANIZATIONUNIT_CODE]", organizationUnitCode)
			);
		}

		const _listClientRecipientsCore = function () {
			const req = {
				method: "get",
				url: getBaseCoreRequestUrl()
			};
			return $http(req);
		};

		return {
			listClientRecipientsCore: _listClientRecipientsCore
		};
	}
]);
